class Timer {
	timerID: number;
	startTime: number;
	remaining: number;

	constructor(delay: number) {
		this.timerID = delay;
		this.startTime = delay;
		this.remaining = delay;
	}

	pause = () => {
		window.clearTimeout(this.timerID);
		this.remaining -= Date.now() - this.startTime;
	};

	resume = () => {
		this.startTime = Date.now();
		window.clearTimeout(this.timerID);
		this.timerID = window.setTimeout(this.onFinish, this.remaining);
		return this;
	};

	start = () => {
		this.resume();
		return this;
	};

	cancel = () => {
		window.clearTimeout(this.timerID);
	};

	onFinish = () => {
		// noop
	};
}

export default Timer;
